import AppDevelopmentOffers from "./AppDevelopmentOffers";

const AppDevelopment = () => {
  return (
    <section className="solution-item-page">
      <AppDevelopmentOffers />
    </section>
  ); 
};

export default AppDevelopment;
